import { gql } from '@apollo/client';

export const TRIP_FRAGMENT = gql`
fragment TripFragment on Trip {
  description
  id
  itinerary {
    date
    dayNumber
    places {
      id
      place {
        id
        actionKind
        name
        stateEquiv
        country
        description
        photos(size:LARGE)
        website
        bookingUrl
        bookingComAccommodation {
          bookingUrl
        }
      }
    }
  }
  photos(size:LARGE)
  regions {
    id
    name
    heroImageUrl
  }
}
`;
